(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vet-testimonial-slider"] && !Shopify.designMode) return;
  try {
    // Self-cleaning custom element: connectedCallback inits, disconnectedCallback tears down.
  // Editor-safe by construction (no shopify:section registry). Config read from data-* (this tag
  // is bundled/static — it cannot read block.settings). Synchronous: timers/listeners only.
  if (!customElements.get('vet-testimonial-slider')) {
    customElements.define('vet-testimonial-slider', class extends HTMLElement {
      connectedCallback() {
        this._ac = new AbortController();
        const signal = this._ac.signal;

        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('.vet-slider__slide'));
        this.dots = Array.from(this.querySelectorAll('.vet-slider__dot'));
        if (!this.viewport || this.slides.length <= 1) return; // static single card — nothing to drive

        this.index = 0;
        this.show = this.show.bind(this);

        // Controls
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.go(-1), { signal });
        if (next) next.addEventListener('click', () => this.go(1), { signal });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const i = parseInt(dot.dataset.dot, 10);
            if (!Number.isNaN(i) && i !== this.index) this.show(i);
          }, { signal });
        });

        // Lightweight swipe (mobile parity without a scroll container).
        let downX = null;
        this.addEventListener('pointerdown', (e) => { downX = e.clientX; }, { passive: true, signal });
        this.addEventListener('pointerup', (e) => {
          if (downX === null) return;
          const dx = e.clientX - downX; downX = null;
          if (Math.abs(dx) > 40) this.go(dx < 0 ? 1 : -1);
        }, { passive: true, signal });

        this.show(0);
      }

      disconnectedCallback() {
        if (this._ac) this._ac.abort();
      }

      show(i) {
        this.slides.forEach((s, n) => {
          const active = n === i;
          s.classList.toggle('is-active', active);
          if (active) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((d, n) => {
          const active = n === i;
          d.classList.toggle('is-active', active);
          if (active) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        this.index = i;
      }

      go(delta) {
        this.show((this.index + delta + this.slides.length) % this.slides.length);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
